import React from 'react'

import Base from '../_Base'

const Star50 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="m15.266 8.352-3.278-6.629L8.73 8.352 1.431 9.397l5.279 5.131-1.245 7.32 6.534-3.458 6.545 3.46-1.259-7.322 5.285-5.13-7.304-1.046zm-3.273-2.107 1.948 3.938 4.313.617-3.118 3.027.748 4.354L12 16.128l-.007-9.883z" />
  </Base>
)

export default Star50
